export const columns = [
  {
    title: "Nombre",
    dataIndex: "nombre",
    width: "10%",
  },
  {
    title: "Descripción",
    dataIndex: "descripcion",
    width: "15%",
  },
  {
    title: "Tipo de logro",
    dataIndex: "tipoLogro",
    width: "7%",
  },
  {
    title: "URL imagen",
    dataIndex: "imagen",
    width: "10%",
  },
  
];
export const formatData = (data) => {
  return {
    idLogro: data.id,
    logr_nombre: data.nombre,
    logr_descripcion: data.descripcion,
    logr_dificultad: data.dificultad,
    logr_imagen: data.imagen,
    tilo_id: data.idTipoLogro,
    nombre: data.nombre
  };
};

export const camposFormulario = (tiposLogros = []) => {
  return {
    title: "Logros",
    campos: [
      {
        name: "idLogro",
        label: "id",
        type: "number",
        hidden: true,
      },
      {
        name: "logr_nombre",
        label: "Nombre del logro",
        type: "text",
        rules: [
          {
            required: true,
            message: "El nombre del logro es obligatorio",
          },
          {
            max: 45,
            message: "El nombre no puede exceder los 45 caracteres",
          },
          {
            min: 1,
            message: "El nombre debe tener al menos 1 caracter",
          },
        ],
      },
      {
        name: "logr_descripcion",
        label: "Descripción",
        type: "text",
        rules: [
          {
            required: true,
            message: "La descripción del logro es obligatoria",
          },
        ],
      },
      {
        name: "logr_dificultad",
        label: "Nivel de dificultad",
        type: "number",
        max: 3,
        min: 1,
        rules: [
          {
            required: true,
            message: "El nivel de dificultad es obligatorio",
          },
        ],
      },
      {
        name: "logr_imagen",
        label: "URL imagen",
        type: "text",
        max: 255,
        rules: [
          {
            required: true,
            message: "La URL de la imagen es obligatoria",
          },
          {
            max: 255,
            message: "La URL no puede exceder los 255 caracteres",
          },
        ],
      },
      {
        name: "tilo_id",
        label: "Tipo de logro",
        type: "select",
        opciones: tiposLogros,
        rules: [
          {
            required: true,
            message: "Debe seleccionar un tipo de logro",
          },
        ],
      },
    ],
  };
};
export const camposFilter = (tiposLogros = []) => ({
  title: "Logros",
  campos: [
    {
      name: "nombre",
      type: "text",
      placeholder: "Nombre logro",
      rules: [
        {
          max: 45,
          message: "El nombre no puede exceder los 45 caracteres",
        },
      ],
    },
    {
      name: "tipoLogro",
      placeholder: "Tipo de logro",
      type: "select",
      opciones: tiposLogros,
    },
  ],
});
